export default {
  namespaced: true,

  state: {
    data: {
      user: null,
    },
  },

  getters: {
    getUser: (state) => state.data.user,
  },

  actions: {
    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },
  },

  mutations: {
    SET_USER(state, payload) {
      state.data.user = payload;
    },
  },
};
